import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function MultiAndFree(props) {

    const {i18n, t} = useTranslation()

    const index = props.surveyUserData.findIndex((el) => el.questionId === props.questionId)
    const [answers, setAnswers] = useState(index !== -1 ? props.surveyUserData[index].answer : {})

    const {updateSurveyData, questionId, question} = props;

    const updateAnswers = (answer) => {
        if (!answers.answers) {
            const newAnswers = {...answers, "answers": [answer]}
            props.updateChangeBehaviour(props.questionId, answers, newAnswers);
            setAnswers(newAnswers)
        }
        else if (answers.answers.includes(answer)) {
            const newAnswers = {...answers, "answers": answers.answers.filter(val => {
                return(val !== answer)
            })}
            props.updateChangeBehaviour(props.questionId, answers, newAnswers);
            setAnswers(newAnswers);
        } else {
            const newAnswers = {...answers, "answers": [...answers.answers, answer]}
            props.updateChangeBehaviour(props.questionId, answers, newAnswers);
            setAnswers(newAnswers)
        }
    }

    const updateFreeAnswer = (e) => {
        setAnswers({...answers, "text": e.target.value})
    } 

    useEffect(() => {
        updateSurveyData(questionId, answers)
    }, [answers, questionId])

    const renderChoices = () => {
        const choices = []

        for (let i=0; i < props.choices.length; i++) {
            let choice = props.choices[i]
            const translatedChoice = choice[i18n.language]
            if (translatedChoice === "") {
                if (answers.answers && answers.answers.includes(i)) {
                choices.push(
                    <Box sx={{display: "flex", alignItems: "center", mb: 1}} key={i}>
                        <IconButton onClick={() => updateAnswers(i)} color="primary">
                            <CheckBox/>
                        </IconButton>
                        <TextField value={answers.text ? answers.text : ""} onChange={updateFreeAnswer} placeholder={t("multiFreePlaceholder")}/>
                    </Box>
                )
                } else {
                    choices.push(<Box sx={{display: "flex", alignItems: "center", mb: 1}} key={i}>
                        <IconButton onClick={() => updateAnswers(i)}>
                            <CheckBoxOutlineBlank/>
                        </IconButton>
                        <TextField value={answers.text ? answers.text : ""} onChange={updateFreeAnswer} placeholder={t("multiFreePlaceholder")}/>
                    </Box>
                )
                }
            }
            else if (answers.answers && answers.answers.includes(i)) {
                choices.push(
                    <Box sx={{display: "flex", alignItems: "center", mb: 1}} key={i}>
                        <IconButton onClick={() => updateAnswers(i)} color="primary">
                            <CheckBox/>
                        </IconButton>
                        <Typography>{translatedChoice}</Typography>
                    </Box>
                )
            } else {
                choices.push(
                    <Box sx={{display: "flex", alignItems: "center", mb: 1}} key={i}>
                        <IconButton onClick={() => updateAnswers(i)}>
                            <CheckBoxOutlineBlank/>
                        </IconButton>
                        <Typography>{translatedChoice}</Typography>
                    </Box>
                )
            }
        }

        return choices
    }

    return(
        <Box sx={{width: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <Typography sx={{fontWeight: 500}}>{question[i18n.language]}</Typography>
            <Box sx={{display: "flex", flexDirection: "column", justifyContent: "space-between", mt: 2, mb: 2}}>
                {renderChoices()}
            </Box>
        </Box>
    )
}